import { RequestError, } from './RequestError';
/**
 * Zurich backend responded with an error.
 *
 * Normally thrown in the data service!
 */
export class BackendError extends RequestError {
    static className = 'BackendError';
    constructor(props) {
        super(props);
    }
}
